<div class="text-center" *ngIf="_userService.loading">
  <i class="fa fa-refresh fa-spin main-color font-size-50"></i>
</div>

<div class="alert alert-success" role="alert" *ngIf="confirmMailMessageSuccess">
  {{ confirmMailMessageSuccess | translate}}
</div>

<div class="alert alert-danger" role="alert" *ngIf="confirmMailMessageDanger">
  {{ confirmMailMessageDanger | translate}}
</div>